var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcpSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4699,
    cy: 15.4699,
    r: 15.4699,
    fill: "black",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5053 6.80118C17.015 6.80118 15.2162 8.79326 14.7364 10.1999C13.8948 12.3645 14.2501 14.0271 14.5632 15.4935L14.5859 15.6002C14.8766 16.9639 15.1509 18.2519 14.7581 19.8685C14.7216 20.0898 14.6567 20.3075 14.5654 20.5154C14.1158 21.5463 13.0964 22.2121 11.9685 22.2121C10.4075 22.2121 9.13744 20.9497 9.13744 19.3976C9.13744 17.8448 10.4075 16.5817 11.9685 16.5817C12.3889 16.5817 12.7929 16.6718 13.1701 16.8489L13.4989 17.0036L13.0893 14.5139L12.96 14.4879C12.6357 14.423 12.302 14.3904 11.9685 14.3904C9.19269 14.3904 6.93457 16.6365 6.93457 19.3976C6.93457 22.1588 9.19269 24.4048 11.9685 24.4048C14.2728 24.4048 16.2781 22.8551 16.8421 20.6486C17.4125 18.9204 17.1459 17.3436 16.768 15.6083L16.7257 15.4152C16.3549 13.7181 16.062 12.3775 16.9453 10.6074C17.4102 9.62714 18.415 8.99354 19.5053 8.99354C21.0657 8.99354 22.3353 10.2559 22.3353 11.808C22.3353 13.36 21.0657 14.6229 19.5053 14.6229C19.1185 14.6229 18.7427 14.5465 18.3874 14.3952L18.0681 14.2595L18.4714 16.7113L18.6041 16.7355C18.8989 16.7885 19.2023 16.8156 19.5053 16.8156C22.2805 16.8156 24.5382 14.5691 24.5382 11.808C24.5382 9.0472 22.2805 6.80118 19.5053 6.80118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcpSwap);
export default __webpack_public_path__ + "static/media/ICPSwap.5ee43f9a0158e86cd438d279e65d039f.svg";
export { ForwardRef as ReactComponent };